import { render } from "./WalletConnectionSuccessModal.vue?vue&type=template&id=1bc5b30a"
import script from "./WalletConnectionSuccessModal.vue?vue&type=script&lang=js"
export * from "./WalletConnectionSuccessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__